// extracted by mini-css-extract-plugin
module.exports = {"pagination-container":"_1DvMy","paginationContainer":"_1DvMy"};